import { captureException } from '@sentry/react';
import errorCodes from './errorCodes.json';

export type ErrorCode = {
  messageKey: string;
  type: string;
};

export type ErrorCodeKey = keyof typeof errorCodes;

export type ApiErrorCode = {
  status: number;
  code: ErrorCodeKey;
};

export const BAD_ARGUMENTS: ApiErrorCode = {
  status: 400,
  code: 'invalid.arguments' as ErrorCodeKey
};

export function toErrorCode(code: string): ErrorCode {
  const errorCode = errorCodes[code as ErrorCodeKey];
  if (!errorCode) {
    console.warn(`Unknown error code: ${code}! Returning unknown error`);

    // Log the error to Sentry
    captureException(new Error('Unknown error code'), {
      extra: { code }
    });

    // Return the unknown error code
    return errorCodes.unknown;
  }

  // Return the found error code
  return errorCode;
}
